<!-- =========================================================
     MODALES / COMPONENTES AUXILIARES
========================================================= -->
<app-recovery>
</app-recovery>
<app-register>
</app-register>
<app-login-error
  [errorData]="loginErrorData">
</app-login-error>
<!-- =========================================================
     TEMPLATE PANEL VISUAL
========================================================= -->
<ng-template #visualPanelContent>
  <!-- =======================================================
       LOADING
  ======================================================== -->
  <ng-container
    *ngIf="
      visualPanelState === 'loading'
    ">
    <!-- Skeleton carrusel -->
    <div
      class="login-visual-skeleton-card"
      aria-hidden="true">
      <!-- Imagen -->
      <div class="visual-skeleton-image">
      </div>
      <!-- Contenido -->
      <div class="visual-skeleton-content">
        <div
          class="
            visual-skeleton-line
            visual-skeleton-line-title
          ">
        </div>
        <div
          class="
            visual-skeleton-line
            visual-skeleton-line-full
          ">
        </div>
        <div
          class="
            visual-skeleton-line
            visual-skeleton-line-medium
          ">
        </div>
        <div class="visual-skeleton-footer">
          <div
            class="
              visual-skeleton-dot
              visual-skeleton-dot-active
            ">
          </div>
          <div class="visual-skeleton-dot">
          </div>
          <div class="visual-skeleton-dot">
          </div>
        </div>
      </div>
    </div>
    <!-- Skeleton tips -->
    <div
      class="login-tip-skeleton"
      aria-hidden="true">
      <div
        class="
          visual-skeleton-line
          visual-skeleton-line-tip
        ">
      </div>
      <div
        class="
          visual-skeleton-line
          visual-skeleton-line-tip-small
        ">
      </div>
    </div>
  </ng-container>
  <!-- =======================================================
       READY
  ======================================================== -->
  <ng-container
    *ngIf="
      visualPanelState === 'ready'
    ">
    <!-- CARRUSEL -->
    <ng-container
      *ngIf="
        adsCarouselFiltered?.length > 0
      ">
      <div class="ad-card">
        <!-- Imagen -->
        <div class="ad-image">
          <div class="ad-frame">
            <img
  [src]="
    getAdImageUrl(
      adsCarouselFiltered[currentIndexAds]
    )
  "
  [alt]="
    adsCarouselFiltered[currentIndexAds]?.title
    || 'Contenido informativo'
  "
  (error)="onActiveCarouselImageError()">
          </div>
        </div>
        <!-- BODY -->
        <div class="ad-body">
          <div class="ad-title">
            {{
              adsCarouselFiltered[currentIndexAds]?.title
            }}
          </div>
          <div class="ad-subtitle">
            {{
              adsCarouselFiltered[currentIndexAds]?.subtitle
            }}
          </div>
          <!-- CTA -->
          <div class="ad-cta">
            <button
              *ngIf="
                adsCarouselFiltered[currentIndexAds]?.link_url
              "
              type="button"
              class="ad-link ad-link-button d-flex align-items-center"
              (click)="
                openAd(
                  adsCarouselFiltered[currentIndexAds]
                )
              ">
              CONOCER MÁS
              <i
                class="
                  fi
                  fi-rr-angle-small-right
                  d-flex
                ">
              </i>
            </button>
          </div>
          <!-- FOOTER -->
          <div class="ad-footer">
            <div
              class="ad-footer-bar"
              *ngIf="
                adsCarouselFiltered.length > 1
              ">
              <!-- DOTS -->
              <div class="ad-dots">
                <span
                  class="ad-dot"
                  *ngFor="
                    let ad
                    of adsCarouselFiltered;
                    let i = index
                  "
                  [class.active]="
                    i === currentIndexAds
                  "
                  (click)="goTo(i)">
                  <span
                    class="ad-dot-fill"
                    [class.animate]="
                      i === currentIndexAds
                    ">
                  </span>
                </span>
              </div>
              <!-- ARROWS -->
              <div class="ad-arrows">
                <button
                  type="button"
                  class="ad-arrow"
                  (click)="prev()">
                  <i
                    class="
                      fi
                      fi-rr-angle-small-left
                      d-flex
                    ">
                  </i>
                </button>
                <button
                  type="button"
                  class="ad-arrow"
                  (click)="next()">
                  <i
                    class="
                      fi
                      fi-rr-angle-small-right
                      d-flex
                    ">
                  </i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- =====================================================
         TIPS
    ====================================================== -->
    <ng-container
      *ngIf="
        tips?.length > 0
      ">
      <div class="tips-pill-wrap">
        <div class="bottom-pill">
          <div class="bottom-pill-text">
            {{
              tips[currentIndexTips]
                ?.con_info_description
            }}
          </div>
        </div>
        <div
          class="pill-dots-out"
          *ngIf="
            tips.length > 1
          ">
          <span
            class="dot"
            *ngFor="
              let tip of tips;
              let i = index
            "
            [class.active]="
              i === currentIndexTips
            "
            (click)="goToTip(i)">
          </span>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <!-- =======================================================
       FALLBACK
  ======================================================== -->
  <ng-container
    *ngIf="
      visualPanelState === 'fallback'
    ">
    <div
      class="visual-fallback-card"
      role="status">
      <div class="visual-fallback-icon">
        <i class="fi fi-rr-info">
        </i>
      </div>
      <strong class="visual-fallback-title">
        {{ visualFallbackTitle }}
      </strong>
      <span class="visual-fallback-subtitle">
        {{ visualFallbackSubtitle }}
      </span>
    </div>
  </ng-container>
</ng-template>
<!-- =========================================================
     WRAPPER
========================================================= -->
<section
  class="
    container-fluid
    m-0
    p-0
    login-container
  ">
  <!-- =======================================================
       BANNER SUPERIOR
  ======================================================== -->
  <ng-container
    *ngIf="
      adsTransversal?.length > 0
    ">
    <div class="top-banner">
      <div
        class="top-banner-content"
        [ngClass]="[
          bannerAnimClass,
          isCurrentTransversalGlobal()
            ? 'banner-global'
            : 'banner-customer'
        ]">
        <div class="top-banner-text">
          {{
            adsTransversal[currentIndexTransversal]?.subtitle
            ||
            adsTransversal[currentIndexTransversal]?.title
          }}
        </div>
        <button
          type="button"
          class="top-banner-close"
          (click)="closeTransversalBanner()">
          ✕
        </button>
      </div>
    </div>
  </ng-container>
  <!-- =======================================================
       LOGIN PAGE
  ======================================================== -->
  <div class="login-page">
    <!-- =====================================================
         BACKGROUND
         IMPORTANTE:
         Mientras visualPanelState !== ready
         solamente existe el color sólido.
    ====================================================== -->
    <div
      class="login-bg"
      [class.visual-ready]="
        visualPanelState === 'ready'
      "
      [class.visual-fallback]="
        visualPanelState === 'fallback'
      "
      aria-hidden="true">
    </div>
    <div class="container-fluid h-100">
<div class="row m-0 login-main-row">
        <!-- =================================================
             PANEL IZQUIERDO
        ================================================== -->
        <div
  class="
    col-12
    col-lg-6
    d-flex
    justify-content-center
    align-items-center
    left-panel
  ">
          <!-- =================================================
               LOGIN PRINCIPAL
          ================================================== -->
          <div class="login-panel">
            <!-- TOP ACTIONS -->
            <div
              class="
                top-actions
                mb-4
                d-flex
                align-items-center
                justify-content-between
              ">
              <!-- VOLVER -->
              <a
                *ngIf="
                  urlVolver?.trim()
                "
                class="
                  back-link
                  help-value
                  d-none
                  d-sm-flex
                  m-0
                "
                [href]="urlVolver"
                target="_blank"
                rel="noopener"
                style="
                  align-items:center;
                  font-size:12px;
                ">
                <i class="fi fi-rr-angle-small-left">
                </i>
                IR AL SITIO WEB
              </a>
              <!-- PERFIL -->
              <div
                *ngIf="
                  showPerfilSwitch
                "
                class="
                  perfil-switch
                  d-none
                  d-sm-flex
                  align-items-center
                "
                [ngClass]="
                  perfil === 'medico'
                    ? 'perfil-medico'
                    : 'perfil-paciente'
                ">
                <mat-slide-toggle
                  class="perfil-toggle"
                  [checked]="
                    perfil === 'medico'
                  "
                  (change)="
                    onPerfilMatToggleChange(
                      $event
                    )
                  ">
                </mat-slide-toggle>
                <span
                  class="perfil-text ml-2"
                  [ngClass]="
                    perfil === 'medico'
                      ? 'perfil-medico-text'
                      : 'perfil-paciente-text'
                  ">
                  {{
                    perfil === 'medico'
                      ? 'Médico'
                      : 'Paciente'
                  }}
                </span>
              </div>
            </div>
            <!-- =================================================
                 LOGOS
            ================================================== -->
            <div
              class="brand text-center"
              [class.brand-two]="
                showSecondaryLogo
              ">
              <img
                [src]="mainLogoUrl"
                alt="AlmaMedis"
                class="brand-logo">
              <img
                *ngIf="
                  showSecondaryLogo
                "
                [src]="secondaryLogoUrl"
                alt="Logo cliente"
                class="brand-logo">
            </div>
            <!-- =================================================
                 FORMULARIO
                 ESTE COMPONENTE SE RENDERIZA SIEMPRE.
                 NO DEPENDE DEL PANEL VISUAL.
            ================================================== -->
            <app-login
              [loginPaciente]="loginPacienteFlag"
              [loginMobile]="false"
              (loginError)="
                onLoginError(
                  $event
                )
              ">
            </app-login>
            <!-- =================================================
                 AYUDA
            ================================================== -->
            <div class="help-box">
              <div class="help-title">
                ¿Tienes problemas para acceder a tu cuenta?
              </div>
              <div class="help-row">
                <!-- MESA AYUDA -->
                <div class="help-item">
                  <div class="help-text">
                    <div class="help-label">
                      Mesa de ayuda
                    </div>
                    <a
                      *ngIf="
                        nroMesaAyuda
                      "
                      class="
                        help-value
                        help-link
                      "
                      [href]="
                        getTelLink(
                          nroMesaAyuda
                        )
                      "
                      style="
                        display:flex;
                        align-items:center;
                      ">
                      <i class="fi fi-rr-phone-call">
                      </i>
                      {{ nroMesaAyuda }}
                    </a>
                  </div>
                </div>
                <!-- CHAT -->
                <div class="help-item">
                  <div class="help-text">
                    <div class="help-label">
                      Chat de ayuda 24/7
                    </div>
                    <a
                      *ngIf="
                        nroChat
                      "
                      class="
                        help-value
                        help-link
                      "
                      [href]="
                        getWhatsappLink(
                          nroChat
                        )
                      "
                      target="_blank"
                      rel="noopener"
                      style="
                        display:flex;
                        align-items:center;
                      ">
                      <i class="fi fi-brands-whatsapp">
                      </i>
                      {{ nroChat }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="help-foot">
                Contáctate a través de nuestros canales de atención
              </div>
              <button
                *ngIf="
                  urlCentroAyuda
                "
                class="help-btn"
                type="button"
                (click)="goCentroAyuda()">
                IR AL CENTRO DE AYUDA
              </button>
            </div>
          </div>
          <!-- =================================================
               CERTIFICACIONES
          ================================================== -->
          <div
            class="login-panel p-2"
            *ngIf="
              certs?.length
            ">
            <div class="certs-wrap">
              <!-- DESKTOP EXACTAMENTE 2 -->
              <ng-container
                *ngIf="
                  showCertsDesktopRows;
                  else certsCarouselBlock
                ">
                <div
                  class="
                    certs-row
                    d-none
                    d-lg-flex
                  ">
                  <div
                    class="cert-item"
                    *ngFor="
                      let c of certs
                    ">
                    <div
                      class="cert-label"
                      *ngIf="
                        c?.title
                      ">
                      {{ c.title }}
                    </div>
                  </div>
                </div>
                <div
                  class="
                    certs-row
                    d-none
                    d-lg-flex
                  ">
                  <div
                    class="cert-item"
                    *ngFor="
                      let c of certs
                    ">
                    <img
                      [src]="
                        URL_DOCS
                        + c.image_url
                      "
                      [alt]="c.title"
                      class="cert-img">
                  </div>
                </div>
              </ng-container>
              <!-- CARRUSEL CERTS -->
              <ng-template
                #certsCarouselBlock>
                <div
                  class="
                    certs-carousel
                    d-flex
                    flex-column
                    align-items-center
                    w-100
                  ">
                  <owl-carousel-o
                    class="w-100"
                    [options]="certOwlOptions"
                    *ngIf="
                      certs?.length
                    ">
                    <ng-template
                      carouselSlide
                      *ngFor="
                        let c of certs;
                        let i = index
                      "
                      [id]="
                        i.toString()
                      ">
                      <div
                        class="
                          cert-item
                          w-100
                        ">
                        <div
                          class="cert-label"
                          *ngIf="
                            c?.title
                          ">
                          {{ c.title }}
                        </div>
                        <img
                          [src]="
                            URL_DOCS
                            + c.image_url
                          "
                          [alt]="c.title"
                          class="cert-img">
                      </div>
                    </ng-template>
                  </owl-carousel-o>
                </div>
              </ng-template>
            </div>
          </div>
          <!-- =================================================
               TABLET
               Usa exactamente la misma máquina de estados
               que el panel derecho.
          ================================================== -->
          <div *ngIf="!isMobile && !isLarge" class="carrousel-ads w-100" style="margin-top:20px;">
            <ng-container
              *ngTemplateOutlet="
                visualPanelContent
              ">
            </ng-container>
          </div>
        </div>
        <!-- =================================================
             PANEL DERECHO DESKTOP
        ================================================== -->
      <div *ngIf="isLarge" class="col-12 col-lg-6 d-flex justify-content-center align-items-center right-panel">
  <div class="right-stack">
    <ng-container
      *ngTemplateOutlet="visualPanelContent">
    </ng-container>
  </div>
</div>
      </div>
    </div>
  </div>
</section>
<!-- =========================================================
     MODAL ADS POPUP
     Se conserva para uso futuro/manual,
     pero ya NO se abre automáticamente
     durante la carga inicial.
========================================================= -->
<div
  class="
    modal
    fade
    ads-popup-modal
  "
  id="adsPopUpModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true">
  <div
    class="
      modal-dialog
      modal-dialog-centered
      modal-lg
    "
    role="document">
    <div
      class="
        modal-content
        ads-popup-content
      "
      *ngIf="
        adsPopUp?.length > 0
      ">
      <i
        class="
          fi
          fi-br-x
          ads-popup-close
        "
        aria-label="Close"
        (click)="closeAdsPopUpModal()">
      </i>
      <div
        class="
          modal-body
          ads-popup-body
        ">
        <!-- CON LINK -->
        <a
          *ngIf="
            adsPopUp[currentIndexAdsPopUp]?.link_url
          "
          class="ads-popup-imgwrap"
          [href]="
            adsPopUp[currentIndexAdsPopUp]?.link_url
          "
          [target]="
            adsPopUp[currentIndexAdsPopUp]?.link_target
            || '_blank'
          ">
          <img
            *ngIf="
              adsPopUp[currentIndexAdsPopUp]?.image_url
            "
            [src]="
              URL_DOCS
              + adsPopUp[currentIndexAdsPopUp]?.image_url
            "
            class="ads-popup-img"
            alt="popup">
        </a>
        <!-- SIN LINK -->
        <div
          *ngIf="
            !adsPopUp[currentIndexAdsPopUp]?.link_url
            &&
            adsPopUp[currentIndexAdsPopUp]?.image_url
          "
          class="ads-popup-imgwrap">
          <img
            [src]="
              URL_DOCS
              + adsPopUp[currentIndexAdsPopUp]?.image_url
            "
            class="ads-popup-img"
            alt="popup">
        </div>
        <!-- CONTROLES -->
        <div
          *ngIf="
            adsPopUp?.length > 1
          "
          class="ads-popup-controls">
          <button
            type="button"
            class="ads-popup-nav"
            (click)="prevAdsPopUp()">
            <i
              class="
                fi
                fi-rs-angle-small-left
                d-flex
              ">
            </i>
          </button>
          <div class="ads-popup-dots">
            <span
              *ngFor="
                let ad of adsPopUp;
                let i = index
              "
              (click)="goToAdsPopUp(i)"
              class="ads-popup-dot"
              [class.active]="
                i === currentIndexAdsPopUp
              ">
            </span>
          </div>
          <button
            type="button"
            class="ads-popup-nav"
            (click)="nextAdsPopUp()">
            <i
              class="
                fi
                fi-rs-angle-small-right
                d-flex
              ">
            </i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
